<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="addLabel"
          >新建标签</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="labelName"
          placeholder="请输入标签名搜索"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        :data="labelSystemList.records"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="标签名"
          prop="labelName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberNum"
          label="会员数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="labelType"
          label="标签类型"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.labelType === 'manual'">手动标签</span>
            <span v-else>自动标签</span>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="groupName"
            label="标签组"
        ></el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip class="item" content="查看会员" placement="top">
                <button class="pointer mr10 no-bg" @click="details(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="labelSystemList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="会员详情"
      :visible="detailsVisible"
      @close="detailsVisible = false"
      width="1200px"
    >
      <div class="table-panel flex flex-end">
        <el-input
          clearable
          v-model.trim="searchCondition.memberName"
          placeholder="请输入会员名搜索"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          v-model.trim="searchCondition.memberMobile"
          placeholder="请输入会员手机号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="searchMember"
          >查询</el-button
        >
        <el-button
          type="success"
          size="small"
          @click="outputDetails"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
      <el-table
        :data="memberList"
        style="width: 100%"
        stripe
        ref="memberList"
        size="small"
        border
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPageMember - 1) * 10 + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="会员手机号"
          prop="memberMobile"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="客户姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="贴标时间"
        ></el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalMember"
          @current-change="pagingMember"
          @size-change="handleSizeChangeMember"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPageMember"
        ></el-pagination>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      searchCondition: {},
      currentPageMember: 1,
      pageSizeMember: 10,
      totalMember: 0,
      memberList: [],
      detailsVisible: false,
      isOutputing: false,
      labelName: "",
      currentPage: 1,
      pageSize: 10,
      row: {}
    };
  },
  computed: mapGetters(["labelSystemList", "alllabelSystemList"]),
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    // 导出excel
    outputDetails() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllLabelMemberList()
          .then(res => {
            const list = res;
            // list.forEach(v => {
            //   v.startDates = v.startDate + "至" + v.endDate;
            // });
            const tHeader = this.$refs.memberList.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);

            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.memberList.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "会员详情" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    async queryAllLabelMemberList() {
      let params = {
        pageNo: 1,
        pageSize: 9999,
        labelId: this.row.labelId
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryAllLabelMemberList",
        params
      );
      const { records } = result;
      return records;
    },
    async queryLabelMemberList() {
      let params = {
        pageNo: this.currentPageMember,
        pageSize: this.pageSizeMember,
        labelId: this.row.labelId
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryLabelMemberList",
        params
      );
      const { records, total } = result;
      this.memberList = records;
      this.totalMember = total;
    },
    pagingMember(page) {
      this.currentPageMember = page;
      this.queryLabelMemberList();
    },
    handleSizeChangeMember(size) {
      this.currentPageMember = 1;
      this.pageSizeMember = size;
      this.queryLabelMemberList();
    },
    queryList() {
      return this.$store.dispatch("queryLabelSystemList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        labelName: this.labelName
      });
    },
    queryAllList() {
      return this.$store.dispatch("queryALLLabelSystemList", {
        pageSize: 99999,
        pageNo: 1
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    details(row) {
      this.row = row;
      this.currentPageMember = 1;
      this.pageSizeMember = 10;
      this.queryLabelMemberList();
      this.detailsVisible = true;
    },
    edit(row) {
      this.$router.push({
        name: "EditLabel",
        query: {
          labelId: row.labelId
        }
      });
    },
    addLabel() {
      this.$router.push({ name: "AddLabel" });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    searchMember() {
      this.currentPageMember = 1;
      this.queryLabelMemberList();
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            const list = this.alllabelSystemList.records;
            list.forEach(v => {
              if (v.labelType == "manual") {
                v.labelType = "手动标签";
              } else {
                v.labelType = "自动标签";
              }
            });
            const tHeader = ["标签名", "会员数", "标签类型"];
            const filterVal = ["labelName", "memberNum", "labelType"];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "标签管理列表" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
